import Vue from 'vue'

Vue.component('font-awesome-icon', {
  props: {
    icon: Array // This could be a class name or any identifier for your icon
  },
  render (h) {
    // Render a span element with the icon class
    return h('span', { class: `icon-${this.icon}` })
  }
})



// WEBPACK FOOTER //
// ./src/bootstrap/fontAwesome.js